export default {
  home: {
    title: "Fast run",
    fastRun: "Fast run"
  }
};
